import {FC, useState} from "react";
import {TeamSpaceItem} from "../../../../../lib/src/api/repositories/documentation-library-repository";
import {useDocumentationLibraryContext} from "@jane/lib/src/components/tiptap/context/DocumentationLibraryContext";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEllipsis, faFolder} from "@fortawesome/pro-regular-svg-icons";
import {faChevronDown, faPlus} from "@fortawesome/free-solid-svg-icons";
import {faChevronRight} from "@fortawesome/pro-solid-svg-icons";
import {TeamSpacePageRow} from "./TeamSpacePageRow";
import {useModal} from "../../../../../lib/src/components/layout/ModalProvider";
import {AddPageModal} from "../../../modals/documentation/AddPageModal";
import {AddFolderModal} from "../../../modals/documentation/AddFolderModal";
import {AddPortal} from "../portals/AddPortal";
import {ContextMenuPortal} from "../portals/ContextMenuPortal";
import {EditFolderModal} from "../../../modals/documentation/EditFolderModal";
import {DeleteFolderModal} from "../../../modals/documentation/DeleteFolderModal";
import {TeamSpace} from "@jane/lib/src/api/repositories/documentation-library-repository";

export const TeamSpaceFolderRow: FC<{ space: TeamSpace, folder: TeamSpaceItem, indentLevel?: number }> = ({ space, folder, indentLevel = 0}) => {
  const { page, pages, templates, getPages, onSpacesUpdated, canEdit } = useDocumentationLibraryContext();
  const subItems = (pages ?? []).filter((item) => item.parentItemId === folder.id)

  const addPageModal = useModal({title: "Pagina toevoegen", body: <AddPageModal teamSpaceId={folder.teamSpaceId} templates={templates} onFinished={() => { onSpacesUpdated();getPages(folder.teamSpaceId) }} parentItemId={folder.id}/>, size: "md"});
  const addFolderModal = useModal({title: "Folder toevoegen", body: <AddFolderModal teamSpaceId={folder.teamSpaceId} onFinished={() => { onSpacesUpdated();getPages(folder.teamSpaceId) }} parentItemId={folder.id}/>, size: 'md'})
  const editFolderModal = useModal({title: "Folder bewerken", body: <EditFolderModal item={folder} onFinished={() => { onSpacesUpdated();getPages(folder.teamSpaceId) }} />, size:'md'})
  const deleteFolderModal = useModal({title: "Folder Verwijderen", body: <DeleteFolderModal item={folder} onFinished={() => { onSpacesUpdated();getPages(folder.teamSpaceId) }} />, size:'md'})

  const recursiveParentMap = new Set<string>();
  let current = page;
  while (current?.parentItemId) {
    const parent = pages.find(p => p.id === current?.parentItemId);

    if (!parent) break;

    if (parent.type === "folder") {
      recursiveParentMap.add(parent.id);
    }

    current = parent;
  }
  const [isExpanded, setIsExpanded] = useState<boolean>(recursiveParentMap.has(folder.id))


  return <div>
    <div style={{paddingLeft: `calc(1rem + ${indentLevel*20}px)`}} className={'my-1 flex flex-row items-center justify-between hover:bg-brand-50 rounded-sm px-2 py-1 group'} onClick={() => setIsExpanded(!isExpanded)}>

      <div className="flex flex-1 min-w-0 flex-row space-x-4 items-center">
        <div className="text-brand-secondary shrink-0">
          <FontAwesomeIcon icon={faFolder} />
        </div>

        <div className="text-sm truncate min-w-0">
          {folder.name.length > 30 ? `${folder.name.slice(0, 30)}...` : folder.name}
        </div>
      </div>

      <div className={"flex items-center gap-x-2 text-sm shrink-0"}>
        {subItems.length > 0 && <FontAwesomeIcon icon={isExpanded ? faChevronDown : faChevronRight}/>}
        {canEdit(space) && <div className={"hidden items-center gap-x-2 group-hover:flex"}>
          <AddPortal trigger={
            <div className="py-0.5 px-0.5 bg-brand-50 hover:bg-brand-100 rounded-sm">
              <FontAwesomeIcon icon={faPlus}/>
            </div>
          } onAddPage={addPageModal.open} onAddFolder={addFolderModal.open}/>

          <ContextMenuPortal trigger={
            <div className="py-0.5 px-0.5 bg-brand-50 hover:bg-brand-100 rounded-sm">
              <FontAwesomeIcon icon={faEllipsis}/>
            </div>
          } onEditItem={editFolderModal.open} onDeleteItem={deleteFolderModal.open}/>
        </div>}
      </div>

    </div>

    {subItems.length > 0 && isExpanded && subItems.map((item, j) => {
      if (item.type === 'page') {
        return <TeamSpacePageRow space={space} item={item} key={j} indentLevel={indentLevel + 1} />
      } else {
        return <TeamSpaceFolderRow space={space} folder={item} key={j} indentLevel={indentLevel + 1} />
      }
    })}
  </div>
}